<button class="view-mode-button" [class.list-mode]="currentViewMode === 'list'" (click)="toggleViewMode()"
    aria-label="Toggle view mode" [attr.aria-pressed]="currentViewMode === 'list' ? 'true' : 'false'">
    <svg viewBox="0 0 24 24" class="view-mode-icon">
        <!-- First rectangle -->
        <rect class="item-one" [attr.x]="currentViewMode === 'list' ? 3 : 3"
            [attr.y]="currentViewMode === 'list' ? 7 : 3" [attr.width]="currentViewMode === 'list' ? 18 : 7"
            [attr.height]="currentViewMode === 'list' ? 3 : 7" rx="1" ry="1" />
        <!-- Second rectangle -->
        <rect class="item-two" [attr.x]="currentViewMode === 'list' ? 3 : 14"
            [attr.y]="currentViewMode === 'list' ? 13 : 3" [attr.width]="currentViewMode === 'list' ? 18 : 7"
            [attr.height]="currentViewMode === 'list' ? 3 : 7" rx="1" ry="1" />
        <!-- Hide third and fourth rectangles in list mode -->
        <rect *ngIf="currentViewMode === 'grid'" class="item-three" x="3" y="14" width="7" height="7" rx="1" ry="1" />
        <rect *ngIf="currentViewMode === 'grid'" class="item-four" x="14" y="14" width="7" height="7" rx="1" ry="1" />
    </svg>
</button>